<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-toolbar-items>
        <slot name="toolbar-items">
          <v-btn v-if="showSaveButton" @click="$emit('save')" flat>
            <v-icon>check</v-icon>
            Save</v-btn
          >
          <v-btn v-if="showCloseButton" small icon color="primary" @click="$emit('close')"
            ><v-icon>close</v-icon></v-btn
          >
        </slot>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <v-card>
        <slot></slot>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
